import { DumpTruckIcon } from './DumpTruckIcon';

/**
 * author: Michael Irigoyen
 * id 50BCAB01-5182-4FBA-9F6D-62DF6872B743
 * name dump-truck
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dump-truck.svg
 * tags
 * - Transportation + Road 
 * - Hardware / Tools 
 */
export const TipperLorryIcon = DumpTruckIcon;
export default TipperLorryIcon